// extracted by mini-css-extract-plugin
export default {"tableContainer":"Table-module_tableContainer__Jh4Wx"};